import { createCanvas } from 'rise-ui/utils/canvas.js';

export class DprCanvas {
  static create(
    width = null, height = null, backgroundColor = null,
    { ratio = null, contextOptions = null } = {}
  ) {
    return new DprCanvas(createCanvas(
      width, height, backgroundColor, contextOptions, ratio
    ));
  }

  constructor(canvas, ratio = null, contextOptions = null) {
    this.canvas = canvas;
    this.ratio = ratio || window.devicePixelRatio;
    this.contextOptions = contextOptions;
  }

  clone() {
    return new DprCanvas(this.canvas, this.ratio, this.contextOptions);
  }

  getCanvas() {
    return this.canvas;
  }

  getTransform(excludeRatio = false) {
    const { ratio } = this;
    return [ excludeRatio ? 1 : ratio, 0, 0, excludeRatio ? 1 : ratio, 0, 0 ];
  }

  getContext(excludeRatio = false) {
    const { canvas, contextOptions } = this;
    const ctx = canvas.getContext('2d', contextOptions);
    ctx.setTransform(...this.getTransform(excludeRatio));
    return ctx;
  }

  drawImage(image, ...args) {
    if (image instanceof DprCanvas) {
      image = image.canvas;
    }
    const { ratio } = this;
    this.getContext(true)
      .drawImage(image, ...args.map(arg => arg && arg * ratio));
  }
}
